import { Fragment, FunctionComponent, useId, useState } from "react";
import { useOnValueChange } from "@pjs/react-utilities";
import { AriaMenuStatus, BoundaryBridge, MenuAriaModel, Select, TextOption } from "@pjs/core-ui";
import { userUiI18n } from "../i18n/UserUiI18n.const";
import { ILanguageProps } from "./interfaces/ILanguageProps";
import { ILanguageOption } from "./interfaces/ILanguageOption";
import "./styles/language.css";

export const Language: FunctionComponent<ILanguageProps> = (props) => {
    const id = useId();
    const options = props.settings.languageChoice.options as Array<ILanguageOption>;
    const [model, setModel] = useState<MenuAriaModel>({
        type: AriaMenuStatus.Closed,
        isOpen: false,
        activeItemIndex: options.findIndex((value) => value.key === props.settings.languageChoice.value)
    });

    useOnValueChange(() => {
        const key = props.settings.languageChoice.options[model.activeItemIndex].key;
        props.actions.languageChoice(key);
    }, [model.activeItemIndex]);

    return (
        <Fragment>
            <h3 className="uui-language__title" id={id}>
                {userUiI18n.getString("language.language_choice.title")}
            </h3>
            <div className="uui-language__select">
                <BoundaryBridge>
                    <Select model={model} onModelChange={setModel} dataSet={options} labelId={id} renderOption={TextOption} />
                </BoundaryBridge>
            </div>
        </Fragment>
    );
};
